/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

export const p6SupportedFormats: ReadonlyArray<string> = [
	'.xls',
	'.xlsx',
	'application/vnd.ms-excel',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
